import { CaseOrderSummary, OrderStatuses } from "@types-runway/case";

const noOrdersYet = "None yet";
const activeStatuses: string[] = [
  OrderStatuses.NEW,
  OrderStatuses.IN_PROGRESS,
  OrderStatuses.OUT_FOR_DELIVERY,
];

// CVIEW-R6: the number of Orders, a dot and the active ones, or the status of the newest Order
// (the first as received, newest first) when none is active.
export const describeCaseOrders = (orders?: CaseOrderSummary[]) => {
  if (!orders?.length) return noOrdersYet;

  const activeCount = orders.filter(({ status }) => activeStatuses.includes(status)).length;
  const summary = activeCount > 0 ? `${activeCount} active` : orders[0].status;

  return `${orders.length} · ${summary}`;
};
